require('../css/reset.css');
require('../css/list.css');
require('../css/video.css');
require('../js/plugins/biliPager.js');

$(function(){
	// 判断登录状态
	function isLogin(){
		var login = false;
		if (getCookie('DedeUserID') && getCookie('DedeUserID__ckMd5') && getCookie('SESSDATA')) {
			login = true;
		}
		return login;
	}
	// 获取cookie
	function getCookie(name){
		var b, c = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		return (b = document.cookie.match(c)) ? b[2] : null;
	}

	// 分享窗口
	function openShareWindow(base, param) {
		var temp = [];
		for (var p in param) {
			temp.push(p + '=' + encodeURIComponent(param[p] || ''));
		}
		var _u = base + temp.join('&');
		window.open(_u, '', 'width=700, height=680, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, location=yes, resizable=no, status=no');
		return false;
	}
	// 解析url
	var show_float = true;
	window.__GetUrlValue = function(name) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	    var r = window.location.search.substr(1).match(reg);
	    if (r != null) {
	        try {
	            return decodeURIComponent(r[2]);
	        } catch(e){
	            return null;
	        }
	    }
	    return null;
	}

	var type = 1;
	var $STAR = {
		gridPreview:$('.grid-preview'),
		voteId:voteId1,
		aids:[],
		playList:function(j_data){
			var that = this;
			$.ajax({
				url:j_data,
				type:'get',
				cache:false,
				dataType:'json',
				success:function(data){
					data = data || {};
					var data = data.list || [];
					data.shuffle();

					// 排序
					(function(){
						function timeSort(a,b){return b.number - a.number;}  //时间
						function coinSort(a,b){return b.ctimes - a.ctimes;}  //硬币
						function clickSort(a,b){return b.click - a.click;}	//点击

			            $('.wrap-video .select-blt .btn').click(function(){
							var $that = $(this);
							var changeBtn = $that.attr('value');
							if($that.hasClass('on') && changeBtn != 'randomSort'){
								return false;
							}

							$('.wrap-video .select-blt .btn').removeClass('on');
							$(this).addClass('on');

			                switch (changeBtn){
			                    case "randomSort":
			                    	data= data.shuffle();
									biliPage();
			                        break;
			                    case "timeSort":
			                    	data= data.sort(timeSort);
									biliPage();
			                        break;
			                    case "coinSort":
									data= data.sort(coinSort);
									biliPage();
			                        break;
			                    case "clickSort":
									data= data.sort(clickSort);
									biliPage();
			                        break;
			                }

			            });
					})()

					// 初始化
					function biliPage(){
					    $('.paging').biliPager({
					        totalItems: data.length, //  总条目数
					        pageItems: 15,  //  每页包含的条目数
					        showedPages: 5,  //  当前页附近显示几个页码
					        currentPage: 1,  //  初始化时显示为第几页
					        edge: 1, //  首页和末页附近显示几个页码
					        addStyle: false,  //  是否在body下加入含有默认皮肤css代码的style标签
					        ellipseText: '...',  // 省略号的自定义文本
					        prevText: '上一页',  //  为false时 去掉上一页按钮
					        nextText: '下一页',  //  为false时 去掉下一页按钮
					        jumpTarget: '.video-header',  //  跳页后是否自动滚动至某一元素，例如；'.top'
					        showJumper: true,  //  是否给出跳页功能，是时则在尾部加入‘共XX页，跳至__页’及跳转按钮的DOM


					        onTurnPage: function(pageIndex) {
					            // 翻页后回调
					            getList(pageIndex,15);
					            $('.paging').biliPager('setPage',pageIndex);
					        },
					        onInit: function(pageIndex) {
								var total = 0, scroe = 0;
								for (var i = 0; i < data.length; i++) {
									score = parseInt(data[i].total_scores);
									total += score;
								}
								$('.go-right .votes').text(total);
								// 参与人数
			                	$('.wrap-video .entry-num > span').text(data.length);
					            getList(pageIndex,15);
					        }
					    });

					}

					biliPage();
					function getList(pageIndex,pageItems){
						that.getFavour();
						$('#video-cont').empty();
						for(var i = (pageIndex-1)*pageItems; i < pageIndex*pageItems ; i++) {
							if(!data[i]){
					    		break;
					    	}else{
					            var scoreWrapper = $('<div class="score-wrapper clearfix" id='+data[i].number+'><a class="score-icon"></a><a class="score-icon"></a><a class="score-icon"></a><a class="score-icon"></a><a class="score-icon"></a></div>');
					            var scoreBlock = $('<input type="text" class="vote-value" value="0"/>');

					            var tmepBlock = '<div class="tp-zp" data-aid="'+data[i].aid+'">' +
									'<div class="img-result" data-src="' + data[i].litpic + '" style="background-image: url(' + data[i].litpic + ');"></div>' +
					                '<div class="t" title="'+data[i].title+'">'+data[i].title+'</div></a>' +
					                '<div class="rate">' +
					                '<div class="pf"><div class="bra"></div><a class="btn" aid="'+data[i].aid+'">评分</a></div>'+
					                '<div class="share-btn">分享</div>'+
					                '</div>';

								//判断是否已评分,确定第一个参数在数组中的位置，如果没有找到则返回-1
								if($.inArray(data[i].aid.toString(), that.aids) >=0) {
									// 隐藏评分那行和评分按钮，显示出分享按钮
									$('.score-wrapper,.pf').css('display', 'none');
									$('.share-btn').css('display', 'block');
								}else{
									// $('.score-wrapper,.pf').css('display', 'block');
									// $('.share-btn').css('display', 'none');
								}
								var block = $(tmepBlock);
								block.appendTo($('#video-cont'));
								scoreWrapper.appendTo(block.find('.rate'));
								scoreBlock.appendTo(block.find('.bra'));
								that.getScore(scoreWrapper,scoreBlock);
					    	}

						}
						// 整页面评分和点击弹窗及其分享自动弹窗
						that.getVote();
						that.bigVideo();

						$('#video-cont').find('.share-btn').off().on('click',function(){

							var share_aid = $(this).parents('.tp-zp').attr('data-aid');
							var share_src = $(this).parents('.tp-zp').find('.img-result').attr('data-src');
							if(type == 1){
								var share_txt = '去了！我喜欢的厂商、游戏出席TGS东京电玩展了！我好兴奋啊！！快来给视频评分投票，展现一波信仰的力量！';
							}else{
								var share_txt = '没去？没在TGS东京电玩展看到喜欢的游戏和厂商诶…没关系，来看应援视频，给喜欢的游戏投票评分！咱们也能玩很high嘛~';
							}
							that.shareVideo(share_aid,share_src,share_txt);
						})

					}

				}
			})
		},

		// 获取用户已经评过分的视频aid
		getFavour:function(){
			var that = this;
			var myvote = 'http://www.bilibili.com/plus/mission_vote.php?msid='+that.voteId+'&act=get_my_vote_scores';
			$.ajax({
				url: myvote,
				type:'get',
				cache: false,
				dataType:'json',
				async: false,
				success:function(data){
					that.aids = data.aids || [];
				}
			})
		},
		// 悬浮点击效果及分数
		getScore:function(scoreWrapper,scoreBlock){
			scoreWrapper.find("a").hover(
			    function(){
			        if(scoreWrapper.find('a[hasmessagebox="yes"]').length>0){
			            return;
			        }
			        var btn = $(this);
			        var index = btn.index();
			        scoreWrapper.find("a:lt("+(index+1)+")").addClass("on");
			        scoreWrapper.find("a:gt("+(index)+")").removeClass("on");
			    },
			    function(){
			        if(scoreWrapper.find('a[hasmessagebox="yes"]').length>0){
			            return;
			        }
			        var btn = $(this);
			        var index = btn.index();
			        if(index==0){
			            scoreWrapper.find("a").removeClass("on");
			        }
			    }
			);
			scoreWrapper.find("a").on("mouseleave",function(){
				scoreWrapper.find("a").removeClass("on");
			})

			scoreWrapper.find("a").click(
			    function(){
			        if(scoreWrapper.find('a[hasmessagebox="yes"]').length>0){
			            return;
			        }
			        var btn = $(this);
			        var index = btn.index();
			        scoreWrapper.find("a:lt("+(index+1)+")").addClass("active");
			        scoreWrapper.find("a:gt("+(index)+")").removeClass("active");
			        var rateScore = (index+1)*2;
			        scoreBlock.attr('value',rateScore)
			    }
			);

		},
		// 整个页面评分
		getVote:function(){
			var that = this;
			$('#video-cont').find('.tp-zp .rate .btn').off().click(function(){
				if(!isLogin()){
					biliQuickLogin(function() {
						window.location.reload();
					});
				}else{
					var sf = this;
					var aid = $(sf).attr("aid");
					var val = parseInt($(sf).parent().find(".vote-value").val());
					console.log(aid,that.voteId,val);
					if(!val){
						new MessageBox({ Overlap:true}).show(sf,'评分数量不正确',2000,'error');
						return false;
					}
					var msgbox = new MessageBox().show(this,'确认对此视频进行评分？','button',function(mobj){
					    $.ajax({
					    	url:"http://www.bilibili.com/m/mission_vote?aid="+aid+"&msid="+that.voteId+"&vote="+val,
	                        headers: {
	                            // 请求头缓存设置，避免浏览器缓存。仅对 XMLHttpRequest 请求有效
	                            // script、jsonp 并不是真正的 XMLHttpRequest 请求，所以这个不适用这两种类型
	                            'Cache-Control': 'no-cache',    // HTTP/1.1
	                            'Pragma': 'no-cache',           // HTTP/1.0
	                            'Expires': '-1'                 // Proxy
	                        },
	                        cache: true, // 不要添加时间戳，避免穿透 CDN 缓存
					        success:function(data){
					            switch(data){
					                case "-1": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'不在可评分时间内',2000,'error'); break;
					                case "-2": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'评分的视频不存在',2000,'error'); break;
					                case "-3": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'您已经对此视频评过分',2000,'error'); break;
					                case "-4": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'您所属的IP评分过于频繁',2000,'error'); break;
					                case "-5": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'评分数量不正确',2000,'error'); break;
					                case "-6": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'请登录符合评分的账号',2000,'error'); break;
					                case "-7": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'您剩余的可评分点数不足',2000,'error'); break;
					                case "0":
					                	new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'评分成功',1000,'ok');
										$(sf).parents('.pf').addClass('default-hidden');
										$(sf).parents('.tp-zp').find('.score-wrapper').addClass('default-hidden');
										$(sf).parents('.tp-zp').find('.share-btn').css('display', 'block');

										var total = parseInt($('.go-right .votes').text());
										total += val;
										$('.go-right .votes').text(total);

					                	break;
					                default:new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'未知错误：'+data,2000,'error');
					            }
					        },
					        error:function(){
					            new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'提交失败',2000,'error');
					        }
					    });

					});
				}
			})
		},
		// 点击显示弹窗视频
		bigVideo:function(){
			var that = this;
			$('#video-cont').find(".tp-zp > .img-result").off().click(function(){
				var $that = $(this).parent('.tp-zp'),
					videoId = $that.attr('data-aid'),
					src = $that.find('.img-result').attr('data-src'),
					txt = $that.find('.t').text();

				that.showVideo(videoId,src,txt);
			})
		},
		// 显示弹窗视频且可以评分
		showVideo:function(videoId,src,txt){
			var that = this;
			// 更新已评分的数组aids
			that.getFavour();
			if($.inArray(videoId.toString(), that.aids) >=0) {
				that.gridPreview.find('.video-right').css('display', 'none');
			}else{
				that.gridPreview.find('.video-right').css('display', 'block');
			}

			var	ifr_video = '<iframe id="bofqi_embed" style="width:100%;height:100%;border:none;overflow: no-scroll;" src="http://www.bilibili.com/html/player.html?aid='+ videoId +'&autoplay=1&as_wide=1&wmode=transparent" wmode="transparent" scrolling="no" border="0" frameborder="no" framespacing="0" onload="window.securePlayerFrameLoaded=true"></iframe>';

			that.gridPreview.attr({
				'data-aid':videoId,
				'data-src': src
			});
			that.gridPreview.find('.title-name').text(txt);
			that.gridPreview.find('.video').empty().append($(ifr_video));
			that.gridPreview.find('.drawyoo-space').attr('href', "http://www.bilibili.com/video/av"+ videoId +"/");
			that.gridPreview.find('.video-state .btn').attr('aid', videoId);
			that.gridPreview.find('.vote-value').attr('value', '0');
			that.gridPreview.fadeIn(0);

			var scoreWrapper = $('.score-big-wrapper');
			var scoreBlock = $('.video-state .bra input');
			that.getScore(scoreWrapper,scoreBlock);
			that.gridPreview.find(".video-state .btn").off().click(function(){
				if(!isLogin()){
					biliQuickLogin(function() {
						window.location.reload();
					});
				}else{
					var sf = this;
					var aid = $(sf).attr("aid");
					var val = parseInt($(sf).parent().find(".vote-value").val());

					if(!val){
						new MessageBox({ Overlap:true}).show(sf,'评分数量不正确',2000,'error');
						return false;
					}
					$.ajax({
						url:"http://www.bilibili.com/m/mission_vote?aid="+aid+"&msid="+that.voteId+"&vote="+val,
                        headers: {
                            // 请求头缓存设置，避免浏览器缓存。仅对 XMLHttpRequest 请求有效
                            // script、jsonp 并不是真正的 XMLHttpRequest 请求，所以这个不适用这两种类型
                            'Cache-Control': 'no-cache',    // HTTP/1.1
                            'Pragma': 'no-cache',           // HTTP/1.0
                            'Expires': '-1'                 // Proxy
                        },
                        cache: true, // 不要添加时间戳，避免穿透 CDN 缓存
					    success:function(data){
					        switch(data){
					            case "-1": new MessageBox({ Overlap:true}).show(sf,'不在可评分时间内',2000,'error'); break;
					            case "-2": new MessageBox({ Overlap:true}).show(sf,'评分的视频不存在',2000,'error'); break;
					            case "-3": new MessageBox({ Overlap:true}).show(sf,'您已经对此视频评过分',2000,'error'); break;
					            case "-4": new MessageBox({ Overlap:true}).show(sf,'您所属的IP评分过于频繁',2000,'error'); break;
					            case "-5": new MessageBox({ Overlap:true}).show(sf,'评分数量不正确',2000,'error'); break;
					            case "-6": new MessageBox({ Overlap:true}).show(sf,'请登录符合评分的账号',2000,'error'); break;
					            case "-7": new MessageBox({ Overlap:true}).show(sf,'您剩余的可评分点数不足',2000,'error'); break;
					            case "0":
					            	new MessageBox({ Overlap:true}).show(sf,'评分成功',1000,'ok');

					            	that.gridPreview.find('.video-right').css('display', 'none');
									// 找到页面中已评分的视频aid
									var tp_zp= $('#video-cont').find('.tp-zp[data-aid=' + aid + ']');
									tp_zp.find('.pf').addClass('default-hidden');
									tp_zp.find('.score-wrapper').addClass('default-hidden');
									tp_zp.find('.share-btn').css('display', 'block');

									var total = parseInt($('.go-right .votes').text());
									total += val;
									$('.go-right .votes').text(total);

					            	break;
					            default:new MessageBox({ Overlap:true}).show(sf,'未知错误：'+data,2000,'error');
					        }
					    },
					    error:function(){
					        new MessageBox({ Overlap:true}).show(sf,'提交失败',2000,'error');
					    }
					});
				}
			});

			that.gridPreview.find('.video-share').off().on('click',function(){
				var share_aid = that.gridPreview.attr('data-aid');
				var share_src = that.gridPreview.attr('data-src');
				if(type == 1){
					var share_txt = '去了！我喜欢的厂商、游戏出席TGS东京电玩展了！我好兴奋啊！！快来给视频评分投票，展现一波信仰的力量！';
				}else{
					var share_txt = '没去？没在TGS东京电玩展看到喜欢的游戏和厂商诶…没关系，来看应援视频，给喜欢的游戏投票评分！咱们也能玩很high嘛~';
				}
				that.shareVideo(share_aid,share_src,share_txt);
			})

			that.closeItem();
		},
		//分享
		shareVideo:function(pid,pic,txt){
			var that = this;
		    openShareWindow('http://service.weibo.com/share/share.php?', {
		        url: shareUrl+'?pid='+pid,
		        type: '3',
		        count: '1',
		        /**是否显示分享数，1显示(可选)*/
		        appkey: '2841902482',
		        /**您申请的应用appkey,显示分享来源(可选)*/
		        title: txt,
		        /**分享的文字内容(可选，默认为所在页面的title)*/
		        pic: pic,
		        /**分享图片的路径(可选)*/
		        searchPic: 'false',
		        ralateUid: '',
		        /**关联用户的UID，分享微博会@该用户(可选)*/
		        language: 'zh_cn',
		        /**设置语言，zh_cn|zh_tw(可选)*/
		        rnd: new Date().valueOf()
		    });
		},
		closeItem:function(){
			var that = this;
			$('#item-close').click(function() {
			    that.gridPreview.find('.video').empty();
			    that.gridPreview.find('.score-big-wrapper a').removeClass('active');
			    that.gridPreview.fadeOut(0);
			});
		},
		other:function(){
			if(type == 1){
				$('.go-arrive,.foot-go').removeClass('no');
				$('.go-right .name').text('去了');
				$('.go-arrive a,.foot-go a').attr('href', 'http://www.bilibili.com/html/activity-TGS2016-list.html?type=2');
			}else{
				$('.go-arrive,.foot-go').addClass('no');
				$('.go-right .name').text('没去');
				$('.go-arrive a,.foot-go a').attr('href', 'http://www.bilibili.com/html/activity-TGS2016-list.html?type=1');
			}

			var date = new Date(serverdate).getTime();
			var date1 = new Date('September 27,2016,00:00').getTime();
			if (date >= date1 ) {
				$('.list-join').css('display', 'none');
			}

		},
		init:function(){
			var that = this;
			type = parseInt(__GetUrlValue('type')) || 1;
			that.other();
			if(type == 1){
				that.voteId = voteId1;
				that.playList('http://www.bilibili.com/list/vote/'+voteId1+'.json');
			}else{
				that.voteId = voteId2;
				that.playList('http://www.bilibili.com/list/vote/'+voteId2+'.json');
			}
		}
	};

	$STAR.init();

})


/** WEBPACK FOOTER **
 ** ./src/js/list.js
 **/